/**
 * @ngInject
 */

function passwordMatch() {

	function link(scope, element, attributes, ngModel) {
		// console.log('scope', attributes);

		ngModel.$validators.matchPassword = function(modelValue, viewValue) {
			if (modelValue !== attributes.passwordMatch) return false;
			return true
		}

		attributes.$observe('passwordMatch', function() {
			ngModel.$validate();
		})

	}

	return {
		require: 'ngModel',
		link: link,
	};
}